import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { Activity } from '@/core/interfaces';
import { formatHMS, secondsToHMS } from '@/app/shared/utils';
import { Tag } from '@/app/shared/components/common';

interface ActivityItemProps {
	activity: Activity;
	categoryIndex: number;
	onClickActivity: (activity: Activity, drawerVisibility: boolean) => void;
}

export const ActivityItem: React.FC<ActivityItemProps> = ({
	activity,
	onClickActivity,
	categoryIndex,
}: ActivityItemProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/
	return (
		<div
			key={activity.id}
			className={`flex gap-4 items-center p-3 rounded-xl relative ${
				categoryIndex === 1
					? activity.buyOnlyOnce || activity.expired
						? activity.userInfo?.currentLevel &&
						  activity.userInfo?.currentLevel > 0
							? 'bg-category-one-gradient brightness-50'
							: 'bg-category-one-gradient'
						: 'bg-category-one-gradient shadow-md'
					: categoryIndex === 2
					? activity.buyOnlyOnce || activity.expired
						? activity.userInfo?.currentLevel &&
						  activity.userInfo?.currentLevel > 0
							? 'bg-category-two-gradient brightness-50'
							: 'bg-category-two-gradient'
						: 'bg-category-two-gradient'
					: categoryIndex === 3
					? activity.buyOnlyOnce || activity.expired
						? activity.userInfo?.currentLevel &&
						  activity.userInfo?.currentLevel > 0
							? 'bg-category-three-gradient brightness-50'
							: 'bg-category-three-gradient'
						: 'bg-category-three-gradient'
					: ''
			}`}
			onClick={() => {
				if (
					activity.userInfo &&
					activity.userInfo?.timerRemainingSeconds === 0 &&
					!activity.expired
				) {
					onClickActivity(activity, true);
				}
			}}
		>
			<div>
				<img
					src={activity.image}
					alt={activity.thumbnail.title}
					width={'100px'}
					className="rounded-xl"
				/>
			</div>

			<div className="flex flex-col justify-between w-[100%]">
				<p className="text-right font-bold text-xs min-h-[16px]">
					{activity.isNew && <Tag type="new" />}
					{activity.buyOnlyOnce || activity.expired ? (
						activity.userInfo?.currentLevel &&
						activity.userInfo.currentLevel > 0 ? (
							<Tag type="owned" />
						) : (
							<Tag type="unique" />
						)
					) : (
						<span className="pl-2">
							lvl {activity.userInfo?.currentLevel || 0}
						</span>
					)}
				</p>
				<div className="flex flex-col">
					<p className="text-sm font-bold">
						{activity.thumbnail.title}
					</p>
					<div className="flex items-center gap-1 min-h-[16px]">
						{((activity.buyOnlyOnce &&
							activity.userInfo?.currentLevel === 0) ||
							!activity.buyOnlyOnce) && (
							<>
								<p className="text-xs font-bold">
									{t('general.cost')}:{' '}
									{numify(
										activity.userInfo &&
											activity.userInfo?.nextLevelPrice >
												0
											? activity.userInfo.nextLevelPrice
											: activity.initialPrice
									)}
								</p>
								<img
									className="drop-shadow-xl"
									src={
										activity.buyOnlyOnce ||
										(activity.expired &&
											activity.userInfo?.currentLevel &&
											activity.userInfo.currentLevel > 0)
											? process.env
													.VITE_COIN_IMAGE_DISABLED
											: process.env.VITE_COIN_IMAGE
									}
									alt={activity.thumbnail.title}
									width={'15px'}
								/>
							</>
						)}
					</div>
				</div>

				{activity.userInfo && activity.userInfo?.currentLevel > 0 ? (
					<div className="flex self-end items-center">
						<img
							className="drop-shadow-lg"
							src={
								activity.buyOnlyOnce ||
								(activity.expired &&
									activity.userInfo?.currentLevel &&
									activity.userInfo?.currentLevel > 0)
									? process.env.VITE_COIN_IMAGE_DISABLED
									: process.env.VITE_COIN_IMAGE
							}
							alt={activity.thumbnail.title}
							width={'20px'}
						/>

						<p className="text-xs font-bold ">
							+
							{activity.userInfo?.accumulatedRewards
								? numify(activity.userInfo.accumulatedRewards)
								: 0}
							/{t('general.hour')}
						</p>
					</div>
				) : (
					<div className="flex self-end items-center h-4"></div>
				)}
			</div>

			{activity.userInfo &&
				activity.userInfo.timerRemainingSeconds > 0 &&
				!activity.expired && (
					<div
						className={`rounded-xl p-6 flex flex-col justify-center bg-vottun-900/85 absolute top-0 left-0 w-full h-full items-center`}
					>
						<p className="text-xs text-yellow-600">
							{t('categories.cooldown')}
						</p>
						<p className="text-xs text-yellow-600">
							{formatHMS(
								secondsToHMS(
									activity.userInfo.timerRemainingSeconds
								)
							)}
							⏳
						</p>
					</div>
				)}
		</div>
	);
};
